import React, {useEffect} from 'react'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUEstadoDocumentos} from '../../../../actions/action-creators'
import {State} from '../../../../reducers'
import { validacionesOnBlurSucursal } from '../../../../actions/gestion-usuario/gu-generales/gu-generales'
import { su_setErrorsFormSucursal } from '../../../../actions/gestion-usuario/estado-documento/estadoDocumento.actions'
import { generalOpenConfirmEdit } from '../../../../actions/general.actions'

const ModalAgregarSucursal = () => {
  const {formSucursal, errorsSucursal, dataSucursales} = useSelector((state: State) => state.gestionUsuario.sucursales)

  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGUEstadoDocumentos, dispatch)

  useEffect(() => {
    return () => {
      dispatch(acciones.gu_ed_ClearFormCrear())
    }
  }, [])

  const cancelar = () => dispatch(acciones.gu_ed_ShowModalCrearEditarDocumento(false))

  const crearDocumento = async (e: any) => {
    e.preventDefault();
    if(formSucursal.mode !== 'add'){
      dispatch(generalOpenConfirmEdit(() => action_crearDocumento(e)))
    } else {
      action_crearDocumento(e)
    }
  }
  const action_crearDocumento = async (e: any) => {

    if(dataSucursales.find(suc => suc.nombre === formSucursal.nombre && suc.idsucursal !== formSucursal.idsucursal)) {
      acciones.su_setErrorsFormSucursal({...errorsSucursal, "nombre": "El nombre de sucursal ya existe"})
      return;
    }

    if (await acciones.su_validacionesCrearSucursal()) return
    if (formSucursal.mode === "add") {
      await acciones.su_crearSucursal()
    } else {
      await acciones.su_editarSucursal();
      await acciones.su_getDocumentosSucursalesList();
    }
    acciones.su_getSucursalesList();
  }

  const handleInputChangeNombre = (e: any) => {
    let errors = {...errorsSucursal}
    errors.nombre = validacionesOnBlurSucursal(e.target.name, e.target.value)
    acciones.su_FormSucursalHandleChange(e);
    dispatch(su_setErrorsFormSucursal(errors));
  }
  const handleInputChangeDireccion = (e: any) => {
    let errors = {...errorsSucursal}
    errors.direccion = validacionesOnBlurSucursal(e.target.name, e.target.value)
    acciones.su_FormSucursalHandleChange(e);
    dispatch(su_setErrorsFormSucursal(errors));
  }
  const handleInputChangeDescripcion = (e: any) => {
    let errors = {...errorsSucursal}
    errors.descripcion = validacionesOnBlurSucursal(e.target.name, e.target.value)
    acciones.su_FormSucursalHandleChange(e);
    dispatch(su_setErrorsFormSucursal(errors));
  }
  const handleInputChangeCodigo = (e: any) => {
    let errors = {...errorsSucursal}
    errors.codigo = validacionesOnBlurSucursal(e.target.name, e.target.value)
    acciones.su_FormSucursalHandleChange(e);
    dispatch(su_setErrorsFormSucursal(errors));
  }
  
  return (
    <ModalBase Styles={{minWidth: '30%', maxWidth: '700px', padding: '2%'}}>
      <form
        className='form-content'
        data-wf-page-id='64b58c72be2b65200b1e6fa6'
        data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
        onSubmit={crearDocumento}
      >
        <div>
          <h3 className='card-title l'>
            {formSucursal.mode === "add" ? 'Agregar Sucursal' : 'Editar Sucursal'}
          </h3>
        </div>
        <div className='separador'></div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='nombre' className='field-label m'>
              Nombre de sucursal
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='nombre'
              placeholder='Nombre de sucursal'
              id='nombre'
              maxLength={40}
              value={formSucursal.nombre}
              onChange={handleInputChangeNombre}  
            />
            {errorsSucursal.nombre && <p className='alert s'>{errorsSucursal.nombre}</p>}
          </div>
          <div className='label-input'>
            <label htmlFor='codigo' className='field-label m'>
              Código de sucursal
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='codigo'
              placeholder='X000'
              id='codigo'
              maxLength={4}
              value={formSucursal.codigo}
              onChange={handleInputChangeCodigo}  
            />
            {errorsSucursal.codigo && <p className='alert s'>{errorsSucursal.codigo}</p>}
          </div>
        </div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='direccion' className='field-label m'>
              Dirección
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='direccion'
              placeholder='Dirección'
              id='direccion'
              maxLength={100}
              value={formSucursal.direccion}
              onChange={handleInputChangeDireccion}
            />
            {errorsSucursal.direccion && <p className='alert s'>{errorsSucursal.direccion}</p>}
          </div>
        </div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='descripcion' className='field-label m'>
              Descripción
            </label>
            <textarea 
              className='m text-field w-input'
              placeholder='Descripción'
              name="descripcion"
              id="descripcion"
              rows={3}
              style={{ resize: 'none' }}
              maxLength={100}
              value={formSucursal.descripcion}
              onChange={handleInputChangeDescripcion}
            />
            {errorsSucursal.descripcion && <p className='alert s'>{errorsSucursal.descripcion}</p>}
          </div>
        </div>
        <div className='separador'></div>
        <div className='w-layout-hflex button-actions'>
          <button type='button' className='m button transparent w-inline-block' onClick={cancelar}>
            <div>Cancelar</div>
          </button>
          <button type='submit' className='m button w-inline-block'>
            <div>{formSucursal.mode === "add" ? 'Agregar' : 'Guardar'}</div>
          </button>
        </div>
      </form>
    </ModalBase>
  )
}

export default ModalAgregarSucursal
